/**
 * 模块名称：
 * @author ：XXXXX
 */
import { Toast } from 'vant';
import {
    getDocumentList,
    getRecommendDistinct,
    getCreateOrder,
    getPositionContract,
    getMustAskQuestionList,
    getDocTop,
    getAddMustAskQuestion,
    getCandidateInfo,
    getOrderList,
    getDocumentPurpose,
    getMatchingList,
    getDownloadFile,
    getRecommend,

    getDocumentFileInfo,
    getQueryCollectedPositionList,
    getIsStopRecommend
} from '@/api/tweet'
const state = {
    mustAskQuestionList: '',
    documentList: [],
    docCount: 0,
    repeatData: [],
    positionContent: '',
    // 推荐||搜藏
    contractList: [],
    // 职能匹配
    matchingList: [],
    matchCount: 0,
    candidateInfo: {},
    orderCount: 0,
    isFirsts: false,

    documentPurpose: '',
    docPurpCount: 0,
    orderIdList: '',
    showRecDialog: false,
    isFirst: false,

}

const mutations = {
    /**
     * 为state项赋值
     * @param state
     * @param data
     */
    setStateItem(state, data) {
        state[data.key] = data.value
    },

}

const actions = {
    /*
        候选人列表
    */
    async requestDocumentList({ state, commit }, data) {
        try {
            const res = await getDocumentList(data)
            if (res.data.code == 200) {
                commit('setStateItem', { key: 'documentList', value: res.data.data.data })
                commit('setStateItem', { key: 'docCount', value: res.data.data.count })
                commit('setStateItem', { key: 'isFirsts', value: true })
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    /*
        推荐查重
    */
    async requestRecommendDistinct({ state, commit }, data) {
        try {
            const res = await getRecommendDistinct(data)
            if (res.data.code == 200) {
                commit('setStateItem', { key: 'repeatData', value: res.data.data })

                data.cb && data.cb(res.data.data)

                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    /*
        获取订单信息
     */
    async requestPositionContract({ state, commit }, data) {
        try {
            const res = await getPositionContract(data)
            if (res.data.code == 200) {
                commit('setStateItem', { key: 'positionContent', value: res.data.data })
                data.cb && data.cb(res.data.data)
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    /*
        推荐
    */
    async requestCreateOrder({ state, commit }, data) {
        try {
            data.source = 1
            const res = await getCreateOrder(data)
            if (res.data.code == 200) {
                if (res.data.data.order_ids) {
                    commit('setStateItem', { key: 'orderIdList', value: res.data.data.order_ids })
                }
                if (res.data.data.id_list) {
                    Toast('查重未通过，请重新选择')
                    window.location.reload()
                }
                data.cb && data.cb()
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    /*
       获取必问问题
   */
    async requestMustAskQuestionList({ state, commit }, data) {
        try {
            const res = await getMustAskQuestionList(data)
            if (res.data.code == 200) {
                commit('setStateItem', { key: 'mustAskQuestionList', value: res.data.data })
                data.cb && data.cb()
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    /*
    提交必问问题
     */
    async requestAddMustAskQuestion({ state, commit }, data) {
        try {
            const res = await getAddMustAskQuestion(data)
            if (res.data.code == 200) {
                data.cb && data.cb()
                Toast('提交成功！')
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    // 置顶
    async requestDocTop({ state, commit }, data) {
        try {
            const res = await getDocTop(data)
            if (res.data.code == 200) {
                data.cb && data.cb()
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    // 候选人详情
    async requestCandidateInfo({ state, commit }, data) {
        try {
            const res = await getCandidateInfo(data)
            if (res.data.code == 200) {
                commit('setStateItem', { key: 'candidateInfo', value: res.data.data })
                data.cb && data.cb()
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    // 接单列表
    async requestOrderList({ state, commit }, data) {
        try {
            const res = await getOrderList(data)
            if (res.data.code == 200) {
                commit('setStateItem', { key: 'orderCount', value: res.data.data.total_count })
                commit('setStateItem', {
                    key: 'contractList',
                    value: res.data.data.position_list
                })
                commit('setStateItem', { key: 'isFirsts', value: true })
                if (data.mact && res.data.data.total_count < 10) {
                    data.cb && data.cb()
                }
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    //收藏列表
    async awaitGetQueryCollectedPositionList({ state, commit }, data) {
        try {
            const res = await getQueryCollectedPositionList(data)
            if (res.data.code == 200) {
                commit('setStateItem', { key: 'orderCount', value: res.data.data.total_records })
                commit('setStateItem', {
                    key: 'contractList',
                    value: res.data.data.position_list
                })
                commit('setStateItem', { key: 'isFirsts', value: true })
                if (data.mact && res.data.data.total_records < 10) {
                    data.cb && data.cb()
                }
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },

    // 候选人想请getDocumentDetail

    // 候选人动态
    async requestDocumentPurpose({ state, commit }, data) {
        try {
            const res = await getDocumentPurpose(data)
            if (res.data.code == 200) {
                //
                commit('setStateItem', { key: 'documentPurpose', value: res.data.data.data })
                commit('setStateItem', { key: 'docPurpCount', value: res.data.data.count })
                data.cb && data.cb()
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    // 职能匹配
    async requestMatchingList({ state, commit }, data) {
        try {
            const res = await getMatchingList(data)
            if (res.data.code == 200) {
                commit('setStateItem', { key: 'matchingList', value: res.data.data.job_list })
                commit('setStateItem', { key: 'matchCount', value: res.data.data.count })
                commit('setStateItem', { key: 'isFirst', value: true })
                data.cb && data.cb()
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    // 下载简历
    async requestDownloadFile({ state, commit }, data) {
        try {
            const res = await getDownloadFile(data)
            if (res.data.code == 200) {

                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    /*
     一件推人推荐
 */
    async requestRecommend({ state, commit }, data) {
        try {
            const res = await getRecommend(data)
            if (res.data.code == 200) {
                if (res.data.data.order_ids) {
                    commit('setStateItem', { key: 'orderIdList', value: res.data.data.order_ids })
                } else {
                    Toast(res.data.message)
                }

                data.cb && data.cb()
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },


    // 获取附件简历
    async getDocumentFileInfo({ state, commit }, data) {
        try {
            const res = await getDocumentFileInfo(data)
            if (res.data.code == 200) {
                data.cb && data.cb(res.data.data)
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    //判断是否禁止推人
    async getIsStopRecommend({ state, commit }, data) {
        try {
            const res = await getIsStopRecommend(data)
            if (res.data.code == 200) {
                data.cb && data.cb(res.data.data)
                return false
            } else {
                Toast(res.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
}

export default {
    state,
    actions,
    mutations,
    namespaced: true,
}
